import { BaseModel } from "model/BaseModel";
import ItemPeriodicidade from "./ItemPeriodicidade";

export default class Periodicidade implements BaseModel {
    id: number;
    codigo: string | null;
    ativa: boolean;
    personalizada: boolean;
    periodo: number;
    tipoPeriodo: string;
    itens : ItemPeriodicidade[] = [];
    dataUltimaGeracao: Date | null;

    constructor(
        id: number = 0, 
        codigo: string | null = null, 
        ativa: boolean = true, 
        personalizada: boolean = false, 
        periodo: number = 0, 
        tipoPeriodo: string = 'M',
        dataUltimaGeracao: Date | null = null
    ) {
        this.id = id;
        this.codigo = codigo;
        this.ativa = ativa;
        this.personalizada = personalizada;
        this.periodo = periodo;
        this.tipoPeriodo = tipoPeriodo;
        this.dataUltimaGeracao = dataUltimaGeracao;
    }
}